<template>
  <div
    v-if="micrositeDetails.socialLinks.length > 0"
    class="flex flex-wrap justify-center gap-2"
  >
    <a
      v-for="(socialLink, socialLinkIndex) in micrositeDetails.socialLinks"
      :key="socialLinkIndex"
      class="block size-8 p-1 transition-opacity active:opacity-50"
      :href="getSocialLinkHref(socialLink)"
      target="_blank"
    >
      <Component
        :is="getMicrositeSocialLinkOption(socialLink.platform).icon"
        class="size-6"
      />
    </a>
  </div>
</template>

<script setup lang="ts">
import { getMicrositeSocialLinkOption } from '@web/components/microsite/MicrositeSocialLinkOptions';
import {
  MicrositeDetails,
  MicrositeDetailsSocialLink,
} from '@web/types/objects/MicrositeDetails';
import { MicrositeSocialLinkValueType } from '@web/enums/MicrositeSocialLinkValueType';

defineProps<{
  micrositeDetails: MicrositeDetails;
}>();

function getSocialLinkHref(socialLink: MicrositeDetailsSocialLink) {
  if (
    getMicrositeSocialLinkOption(socialLink.platform).valueType ===
    MicrositeSocialLinkValueType.EMAIL
  ) {
    return `mailto:${socialLink.url}`;
  }

  return socialLink.url;
}
</script>
